import script from "./PresetAmountButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PresetAmountButton.vue?vue&type=script&setup=true&lang=ts"

import "./PresetAmountButton.vue?vue&type=style&index=0&id=09bff83c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09bff83c"]])

export default __exports__